<template>
  <base-section id="theme-features">
    <base-section-heading title="Was uns wichtig ist" />

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          title: 'Nachhaltigkeit',
          icon: 'mdi-bio',
          text: 'Wir legen großen Wert darauf, dass unsere Produkte aus nachhaltiger Herstellung stammen.',
        },
        {
          title: 'Lokal',
          icon: 'mdi-flower-outline',
          text: 'Unsere Küche zeichnet sich durch die vorwiegende Verwendung lokaler Produkte aus. Alpenländische und mediterrane Küche vermischen sich und sorgen für wahre Gaumenfreuden.',
        },
        {
          title: 'Qualität',
          icon: 'mdi-check-all',
          text: 'Wir verwenden und vertreiben Qualitätsprodukte aus Südtirol',
        },
        {
          title: 'Einfache Zahlung',
          icon: 'mdi-cash-multiple',
          text: 'Die Zahlung kann ganz einfach mittels Kreditkarte oder bei Abholung erfolgen',
        },
      ],
    }),
  }
</script>
